<div
  class="publish"
  data-test="publishDialog"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'Publish'">
  <h2 class="publish__heading text-20 text-medium">Publish</h2>

  <div class="publish__contents">
    <app-publish *ngIf="bookmark" [model]="bookmark"> </app-publish>
  </div>

  <button
    app-button
    buttonType="text"
    buttonTheme="light"
    type="button"
    (click)="closeDialog()"
    title="Close"
    [attr.aria-label]="'Close'"
    class="publish__close">
    <app-icon icon="times" size="lg"> </app-icon>
  </button>
</div>
